import Vue from 'vue';
import 'vuetify/src/stylus/app.styl';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vuetify, {
  VApp,
  VBtn,
  VIcon,
  VTextField,
  VTextarea,
  VDataTable,
  VDivider,
  VImg,
  VFooter,
  VSelect,
  VProgressCircular,
  VAlert,
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VIcon,
    VTextField,
    VTextarea,
    VDataTable,
    VDivider,
    VImg,
    VFooter,
    VSelect,
    VAlert,
    VProgressCircular,
  },
  iconfont: 'md',
  theme: {
    primary: '#00a3e0',
    secondary: '#424242',
    accent: '#00a3e0',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
});
